import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { TaxDocumentTypeService } from '../../../../core/services/tax-document/tax-document-type/tax-document-type.service'

@Component({
  selector: 'tax-document-client-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
  ],
  templateUrl: './tax-document-client-form.component.html',
  styleUrl: './tax-document-client-form.component.scss',
  providers: [TaxDocumentTypeService],
  standalone: true,
})
export class TaxDocumentClientFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private taxDocumentTypeService: TaxDocumentTypeService,
  ) {}

  form: FormGroup = new FormGroup({})
  loading = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}
  @Input() optional = false

  listType: any[] = []

  ngOnInit(): void {
    this.getListType()
    this.createForm()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  getListType() {
    this.taxDocumentTypeService.listTaxDocumentType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.idCreate) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.form.get('taxDocumentType')?.setValue(this.editItem.tipo_documento_id)
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      taxDocumentType: ['', this.optional ? [] : [Validators.required]],
    })
  }

  getTypeDescription() {
    const typeId = this.form.get('taxDocumentType')?.value
    if (typeId) {
      const element = this.listType.find((ele: any) => {
        return ele.id === typeId
      })
      return element.descricao
    } else {
      return ''
    }
  }

  createAddress() {
    this.loading = true
    const model = this.createModel()
    this.response.emit({ action: 'create', item: model })
    this.resetForm()
    this.loading = false
  }

  editAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'edit', item: model })
    this.resetForm()
    this.loading = false
  }

  deleteAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'delete', item: model })
    this.resetForm()
    this.loading = false
  }

  cancel() {
    this.response.emit({ action: 'cancel' })
    this.resetForm()
  }

  createModel(edit = false) {
    if (edit) {
      return {
        idCreate: this.editItem.idCreate,
        tipo_documento_id: this.form.controls['taxDocumentType'].value,
        tipo_documento: this.getTypeDescription(),
      }
    } else {
      return {
        tipo_documento_id: this.form.controls['taxDocumentType'].value,
        tipo_documento: this.getTypeDescription(),
      }
    }
  }
}
